import screens from "./screens";
import { isBrowser } from "utils/nookies/utils";
import { EnumScreenNames } from "../enums/EnumScreenNames";
import { CookiesConstants ,SHOBIDDAK} from "utils/constants";
import {ILoggingAPIBody} from "../libs/logging/types/loggingTypes";
import {ENUMSELLERFLOWTYPES} from "../types";

export let masterPageScreen;
export let dialogPageScreen;
export let gtmScreenName;

const PAGE_VIEW_BLOCKING_TIMEOUT = 500;
const getDefaultGtmParams = () => {
  getAbbrFromUrl();
  window.gtmDefaultParams.Country = getAbbrFromUrl();
  return window.gtmDefaultParams || {};
};
const getExtraGtmParamsWithDefault = () => {
  return { ...getDefaultGtmParams(), ...(window.gtmExtraData || {}) };
};

export const getAbbrFromUrl = () => {
  const url = isBrowser() && window.location.href;
  const regex = /https?:\/\/(.+?)\./;
  const match = url.match(regex);
  let result;
  if (match && match[1] === SHOBIDDAK) {
    result = 'ps';
  } else {
    result = match ? (match[1].length === 2 && match[1]) : null;
  }
  return result;
};

export const trackEvent = (
  action,
  label,
  type = null,
  isDialogEvent = false,
  ignoreLabel = false,
  extraData = null
) => {
  let firstVisit = true;
  if (!isBrowser()) return;
  window.dataLayer = window.dataLayer || [];
  const screenKey = isDialogEvent ? dialogPageScreen : masterPageScreen;
  const { screenName } = screens[screenKey] || {};
  if (ignoreLabel === false) {
    window["gtmLastAction"] = label;
  }
  window.dataLayer.push({
    ...(extraData && typeof extraData === "object"
      ? { ...getDefaultGtmParams(), ...extraData }
      : getExtraGtmParamsWithDefault()),
    Screen: screenName,
    event: "UserInteraction",
    eventAction: action,
    eventCategory: type ? type : "empty",
    eventLabel: label,
  });
};
export const trackEventSellerWithExtraParams = (
  // events related to postView most of the time
  action,
  label,
  extraData = {}
) => {
  trackEventSeller(action, label, false, false, extraData);
};
export const trackEventSeller = (
  action,
  label,
  isDialogEvent = false,
  ignoreLabel = false,
  extraData = null,
  type = ENUMSELLERFLOWTYPES.addpost
) => {
  trackEvent(action, label, type, isDialogEvent, ignoreLabel, extraData);
};

export const trackEventBuyerWithExtraParams = (
  // events related to postView most of the time
  action,
  label,
  extraData = {}
) => {
  trackEventBuyer(action, label, false, false, extraData);
};
export const trackEventBuyer = (
  action,
  label,
  isDialogEvent = false, // for SLR events most of the time
  ignoreLabel = false,
  extraData = null
) => {
  trackEvent(action, label, "Buyers", isDialogEvent, ignoreLabel, extraData);
};

export const trackEventWithNoCategory = (
  action,
  label,
  isDialogEvent = false,
  ignoreLabel = false
) => {
  trackEvent(action, label, "", isDialogEvent);
};

export const trackVirtualPageView = (screenName: string) => {
  window.dataLayer.push({
    ...getExtraGtmParamsWithDefault(),
    Screen: screenName,
    event: "ScreenView",
    screenName: screenName,
  });
};

let isBlocked = {};
export const trackPageView = (
  screenKey: EnumScreenNames | string,
  isDialog = false,
  timeout = 0
) => {
  if (!isBrowser()) return;
  if (isBlocked?.[screenKey]) return;
  isBlocked[screenKey] = true;
  setTimeout(() => (isBlocked[screenKey] = false), PAGE_VIEW_BLOCKING_TIMEOUT);

  window.trackEventSeller = trackEventSeller;
  window.trackEventBuyer = trackEventBuyer;
  window.trackEventBuyerWithExtraParams = trackEventBuyerWithExtraParams;
  window.dataLayer = window.dataLayer || [];

  const { screenName } = screens[screenKey];
  if (isDialog) {
    dialogPageScreen = screenKey;
  } else {
    masterPageScreen = screenKey;
  }
  // = localStorage.get ?? '';
  window["gtmPrevScreen"] = localStorage.getItem("currentScreen") ?? "";

  window.Screen = screenName;
  gtmScreenName = screenName;
  localStorage.setItem("currentScreen", screenName);

  // added current screen and last three screens  to cookies  and localstorage
  const currentScreen = localStorage.getItem("currentScreen");
  const lastThreeScreens = localStorage.getItem(
    CookiesConstants.LAST_THREE_SCREENS
  );
  if (!lastThreeScreens) {
    localStorage.setItem(CookiesConstants.LAST_THREE_SCREENS, currentScreen);
  }
  if (lastThreeScreens) {
    let threeScreens = lastThreeScreens.split(",");
    if (threeScreens.length === 3) {
      threeScreens.shift();
    }
    if (threeScreens.length < 3) {
      threeScreens.push(currentScreen);
    }
    localStorage.setItem(
      CookiesConstants.LAST_THREE_SCREENS,
      threeScreens.join()
    );

  }

  const cp = () => {
    window.dataLayer.push(
      JSON.parse(
        JSON.stringify({
          ...getExtraGtmParamsWithDefault(),
          Screen: screenName,
          event: "ScreenView",
          screenName: screenName,
        })
      )
    );
  };
  if (timeout) {
    setTimeout(cp, timeout);
  } else {
    cp();
  }
};
export const trackLoggingEvent = (
    body:ILoggingAPIBody
)=>{
  window?.dataLayer?.push({
    event: "OSLogging",
    ...body
  });

};
